module.exports = __webpack_public_path__ + "45a7b33cf1f8227b4f6a4daaeb9de294.MP3";